import { FilterResult } from '../../../repository.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { Observable } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
	selector: 'wncm-form-control-select',
	templateUrl: './form-control-select.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-select.component.scss']
})
export class FormControlSelectComponent extends FormControlComponent implements OnInit {
	@Input()
	from: Observable<FilterResult<any>>;

	@Input()
	label: string;

	@Input()
	multiple: boolean;

	@Input()
	readOnly: boolean;

	options = [];

	private items: FilterResult<any>;

	constructor(private translate: TranslateService) {
		super();

		if (this.readOnly) {
			this.control.disable();
		}
	}

	ngOnInit() {
		super.ngOnInit();
		this.from.subscribe((items) => {
			this.items = items;
			this.refreshOptions();
		});
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.refreshOptions();
		});
	}

	private refreshOptions() {
		this.options = this.items.items
			? this.items.items.map<SelectOption>(
					(i) =>
						<SelectOption>{
							id: i.id,
							label: this.label === 'translationKey' ? this.translate.instant(i[this.label]) : i[this.label],
							icon: i.isBlocked == true ? true : null
						}
			  )
			: [];
	}
}

export class SelectOption {
	id: any;
	label: string;
	icon?: any;
}
